export function StateView({
  message,
  variant = "info",
}: {
  message: string;
  variant?: "info" | "error";
}) {
  return (
    <section
      className="card admin-state-view"
      data-variant={variant}
      style={{ borderColor: variant === "error" ? "#5b2323" : "#25314d" }}
    >
      {message}
    </section>
  );
}
